import styled from "styled-components/macro";
import {
  TextSmRegular,
  Text2xlBold,
} from "../../../../../components/Typography/TypographyV2";
import type { ApprovalSummaryTile } from "../../../../../types/types.Workflow";

const TilesRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: ${({ theme }) => theme.resolve("spacing_lg")};
  margin-bottom: ${({ theme }) => theme.resolve("spacing_3xl")};

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const Tile = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.resolve("spacing_xs")};
  min-width: 0;
  padding: ${({ theme }) => theme.resolve("spacing_lg")};
  background: ${({ theme }) => theme.resolve("color_bg_surface_standard")};
  border: ${({ theme }) => theme.resolve("border_md")} solid
    ${({ theme }) => theme.resolve("color_border_lighter")};
  border-radius: ${({ theme }) => theme.resolve("radius_xs")};
`;

const TileSkeletonBar = styled.div`
  height: 14px;
  width: 72%;
  max-width: 160px;
  border-radius: ${({ theme }) => theme.resolve("radius_xs")};
  background: ${({ theme }) => theme.resolve("color_bg_surface_subtle")};
`;

const TileSkeletonCount = styled.div`
  height: 28px;
  width: 48px;
  border-radius: ${({ theme }) => theme.resolve("radius_xs")};
  background: ${({ theme }) => theme.resolve("color_bg_surface_subtle")};
`;

export type ApprovalsSummaryTilesProps = {
  tiles: ApprovalSummaryTile[];
  isLoading?: boolean;
};

export function ApprovalsSummaryTiles({
  tiles,
  isLoading = false,
}: ApprovalsSummaryTilesProps) {
  if (!isLoading && !tiles.length) {
    return null;
  }

  if (isLoading && !tiles.length) {
    return (
      <TilesRow aria-busy="true">
        {[0, 1, 2].map((index) => (
          <Tile key={index}>
            <TileSkeletonBar />
            <TileSkeletonCount />
          </Tile>
        ))}
      </TilesRow>
    );
  }

  return (
    <TilesRow>
      {tiles.map((tile) => (
        <Tile key={tile.key}>
          <TextSmRegular color="secondary">{tile.heading}</TextSmRegular>
          <Text2xlBold color="primary">{tile.count}</Text2xlBold>
        </Tile>
      ))}
    </TilesRow>
  );
}
